export default __webpack_public_path__ + "static/media/agent.67cb1535.jpg";